/** Removes ANSI colors, cursor controls, and OSC sequences from captured terminal text. */
const ANSI_PATTERN = [
  "[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d/#&.:=?%@~_]*)*)?\\u0007)",
  "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))",
].join("|");

// Hoisted: stripAnsiCodes runs on every captured line, so avoid a per-call RegExp
// allocation. `String.replace` resets `lastIndex` for global regexes, so
// sharing one instance is safe.
const ANSI_RE = new RegExp(ANSI_PATTERN, "g");

export function stripAnsiCodes(input: string): string {
  return input.replace(ANSI_RE, "");
}
